export const depresion_catalog = [


    {
        "n": 1,
        "pregunta": "Conciliar el sueño",
        "respuestas": [
            'Nunca tardé más de 30 minutos en dormirme.',
            'Tardé por lo menos 30 minutos en dormirme, menos de la mitad de las veces.',
            'Tardé por lo menos 30 minutos en dormirme, más de la mitad de las veces.',
            'Tardé más de 60 minutos en dormirme, más de la mitad de la veces']
    },
    {
        "n": 2,
        "pregunta": "Al dormir durante la noche",
        "respuestas": [
            "No me desperté durante la noche.",
            "Tuve el sueño liviano e intranquilo; me desperté unas cuantas veces todas las noches por corto tiempo.",
            "Me desperté al menos una vez cada noche, pero volví a dormirme fácilmente.",
            "Me desperté más de una vez cada noche y me quedé despierto/a durante 20 minutos o más, más de la mitad de las veces"]
    },
    {
        "n": 3,
        "pregunta": " Despertarse demasiado temprano",
        "respuestas": [
            'La mayoría de las veces me desperté no más de 30 minutos antes de lo necesario.',
            'Más de la mitad de las veces me desperté más de 30 minutos antes de lo necesario.',
            'Casi siempre me desperté por lo menos una hora antes de lo necesario, pero finalmente me dormí nuevamente',
            'Me desperté por lo menos una hora antes de lo necesario y no pude volver a dormirme']
    },
    {
        "n": 4,
        "pregunta": " Dormir demasiado",
        "respuestas": [
            'Dormí no más de 7-8 horas por noche, sin haber dormido la siesta durante el día.',
            'Dormí no más de 10 horas en un período de 24 horas, incluyendo las siestas.',
            'Dormí no más de 12 horas en un período de 24 horas, incluyendo las siestas.',
            'Dormí más de 12 horas en un período de 24 horas, incluyendo las siestas.']
    },
    {
        "n": 5,
        "pregunta": "Sensación de tristeza",
        "respuestas": [
            'No me sentí triste.',
            'Me sentí triste menos de la mitad de las veces.',
            'Me sentí triste más de la mitad de las veces.',
            'Me sentí triste casi todo el tiempo.']
    }
]

export const disminucion_apetito = [
    'Mi apetito no disminuyó.',
    'Comí con considerable menor frecuencia o menor cantidad de comida de lo habitual.',
    'Comí mucho menos de lo habitual y sólo haciendo un esfuerzo.',
    'Casi no comí dentro de un período de 24 horas, y sólo haciendo un tremendo esfuerzo o cuando los demás me convencieron de comer'
]

export const aumento_apetito = [
    'Mi apetito no aumentó.',
    'Sentí la necesidad de comer con más frecuencia de lo habitual.',
    'A menudo comí con más frecuencia y/o más cantidad de comida de lo habitual.',
    'Me sentí impulsado/a a comer de más, tanto en las comidas como entre las comidas.',
]

export const perdida_peso = [
    'No he perdido peso.',
    'Siento que tuve una leve pérdida de peso.',
    'He perdido 1 kg o más.',
    'He perdido 2 kg o más.',
]

export const aumento_peso = [
    'No he aumentado de peso.',
    'Siento que tuve un leve aumento de peso.',
    'He aumentado 1 kg o más.',
    'He aumentado 2 kg o más.'
]

export const depresion_catalog2 = [
    {
        "n": 10,
        "pregunta": "Concentración/Toma de decisiones",
        "respuestas": [
            'No hubo cambio en mi capacidad habitual para concentrarme o tomar decisiones.',
            'A veces me sentí indeciso/a o me di cuenta de que me distraía.',
            'La mayor parte del tiempo tuve que esforzarme para mantener la atención o para tomar decisiones.',
            'No me pude concentrar suficientemente bien para leer ni tampoco pude tomar decisiones sin importancia']
    },
    {
        "n": 11,
        "pregunta": "Percepción de mí mismo/a",
        "respuestas": [
            'Me consideré que valgo tanto y que tengo los mismos derechos que las demás personas.',
            'Me sentí más culpable de lo habitual.',
            'En gran medida, creí que le causé problemas a otras personas.',
            'Pensé casi constantemente en mis defectos, tanto en los importantes como en los triviales.',]
    },
    {
        "n": 12,
        "pregunta": "Pensamientos de muerte o suicidio",
        "respuestas": [
            'No pensé en el suicidio o la muerte.',
            'Sentí que mi vida estaba vacía y me pregunté si valía la pena vivir.',
            'Pensé en el suicidio o la muerte varias veces en la semana durante varios minutos.',
            'Pensé en el suicidio o la muerte varias veces al día con cierto detalle, o hice planes de cómo suicidarme, o realmente intenté quitarme la vida.']
    },
    {
        "n": 13,
        "pregunta": "Interés general",
        "respuestas": [
            'No hubo cambio de lo habitual en cuanto a mi interés en otras personas o actividades.',
            'Noté que estaba menos interesado / a en la gente o en las actividades.',
            'Me di cuenta que sólo me interesaban una o dos de las actividades que solía hacer.',
            'No tuve prácticamente ningún interés en las actividades que solía hacer.']
    },
    {
        "n": 14,
        "pregunta": "Nivel de energía",
        "respuestas": [
            'No hubo cambio en mi nivel de energía habitual.',
            'Me cansé más fácilmente de lo habitual.',
            'Tuve que hacer un gran esfuerzo para empezar o terminar mis actividades diarias habituales(porejemplo: hacer las compras, estudiar, cocinar o ir a trabajar).',
            'Realmente, no pude realizar la mayoría de mis actividades diarias habituales porque simplementeno tuve energías.']
    },
    {
        "n": 15,
        "pregunta": " Sensación de estar más lento/a",
        "respuestas": [
            'Pensé, hablé y me moví a mi nivel de velocidad habitual.',
            'Me di cuenta de que mi pensamiento estaba más lento de lo habitual o que mi voz sonabamonótona y achatada.',
            'Tardé varios segundos para responder la mayoría de las preguntas y estoy seguro / a de que mipensamiento estaba más lento de lo habitual.',
            'Con frecuencia no pude responder preguntas si no era haciendo un extremo esfuerzo.']
    },
    {
        "n": 16,
        "pregunta": " Sensación de inquietud",
        "respuestas": [
            'No me sentí inquieto/a.',
            'Con frecuencia me sentí intranquilo/a, me apretaba las manos o necesitaba cambiar la posición enla que estaba sentado/a.',
            'Tuve impulsos de estar en movimiento y me sentí bastante inquieto/a.',
            'Por momentos, me resultó imposible quedarme sentado/a y comencé a dar vueltas.']
    },
]